class FnPurchaseDock extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.root = document.getElementById(`ProductSection-${this.dataset.sectionId}`);
    this.form = document.getElementById(this.dataset.formId);
    this.mainButton = this.form?.querySelector('[data-add-to-cart]');
    if (!this.root || !this.form || !this.mainButton) return;
    this.button = this.querySelector('[data-dock-buy]');
    const sync = () => {
      this.button.disabled = this.mainButton.disabled;
      this.button.textContent = this.mainButton.querySelector('[data-add-to-cart-text]')?.textContent.trim() || this.mainButton.textContent.trim();
      this.querySelector('[data-dock-price]').textContent = this.root.querySelector('[data-product-price]')?.textContent.trim() || '';
    };
    this.button.addEventListener('click', () => {
      if (this.form.reportValidity()) this.mainButton.click();
    }, { signal: this.abort.signal });
    this.root.addEventListener('variantChange', event => {
      const variant = event.detail.variant;
      this.querySelector('[data-dock-variant]').textContent = variant?.title === 'Default Title' ? '' : (variant?.title || '');
      requestAnimationFrame(sync);
    }, { signal: this.abort.signal });
    this.mutation = new MutationObserver(sync);
    this.mutation.observe(this.mainButton, { attributes: true, childList: true, subtree: true });
    this.observer = new IntersectionObserver(entries => {
      this.hidden = entries[0].isIntersecting;
    }, { threshold: 0 });
    this.observer.observe(this.mainButton);
    sync();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.mutation?.disconnect();
    this.observer?.disconnect();
  }
}
if (!customElements.get('fn-purchase-dock')) customElements.define('fn-purchase-dock', FnPurchaseDock);
